import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';
import PatientPlanFeatures from '@views/ManageAccount/Plan/index';

const messages = defineMessages({
  title: {
    id: 'manageAccount.plan',
    defaultMessage: 'Plan',
  },
});

export default function ManagePlanPage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user_id }) => <PatientPlanFeatures user_id={user_id} />}
    </ManageAccountLayout>
  );
}
